import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopLink',
  props: {
  /**
   * Profile ID to be pulled from the store
   *
   * @required
   */
  profileId: {
    type: String,
    required: true,
  },
  showAvatar: {
    type: Boolean,
    default: false,
  },
  textClass: {
    type: String,
    default: "text-subtitle-subtitle1-sofiapro",
  },
},
  setup(__props) {

const props = __props;


const store = useStore();

const displayName = computed(() => profile.value?.displayName);

const profile = computed(() => getProfilesStore(store).getProfileById(props.profileId));

return { __sfc: true,props, store, displayName, profile }
}

})